export enum ContactType {
  PickupAndDeliver,
  Origin,
  Destination,
}
